import { render, staticRenderFns } from "./dialog1.vue?vue&type=template&id=5b637e8b&"
import script from "./dialog1.vue?vue&type=script&lang=js&"
export * from "./dialog1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports